import {
  DEFAULT_DONUT_ICON_STYLES,
  DEFAULT_DONUT_ICONS,
} from "@/components/Donut/Donut.helpers";
import { RegisteredComponent } from "@builder.io/sdk-react";

export const donutBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Donut",
  image:
    "https://icons.veryicon.com/png/o/food--drinks/food-icon-7/donut-14.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  inputs: [
    ...Array.from({ length: 4 }, (_, i) => ({
      name: `icon${i + 1}`,
      type: "uiBlocks",
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          component: {
            name: "Image",
            options: {
              source: "aprimo",
              alt: "Placeholder",
              image: DEFAULT_DONUT_ICONS[i],
            },
          },
          responsiveStyles: {
            large: DEFAULT_DONUT_ICON_STYLES,
          },
        },
      ],
    })),
  ],
  requiresParent: {
    message:
      "This component must be nested within the Horizontal Tab component",
    component: "Horizontal Tab",
  },
};
